import { useT } from '@/shared/i18n'

import { DueSoonView } from './DueSoonView'

/** `/due-soon` — todo lo que vence, de todas las empresas. */
export function DueSoonPage() {
  const t = useT()

  return <DueSoonView title={t('nav.dueSoon')} description={t('dueSoon.description')} />
}
